import theme from './offset.scss';

const $sides = {
    top: 'top', 
    right: 'right', 
    bottom: 'bottom', 
    left: 'left'
};

export function classNames(type, modifiers = {}, value = 0) {
    const classNames = [];
    let currentSize = 'xs';

    Object.keys(modifiers).map((modifier) => {
        if ($sides.hasOwnProperty(modifier)) {
            classNames.push(type + '-' + modifier);
        } else {
            currentSize = modifier;
        }
    });

    if (!classNames.length) {
        Object.keys($sides).map((key) => {
            classNames.push(type + '-' + $sides[key]);
        });
    }

    return classNames.reduce((c, className) => {
        return c += theme[className + `-${currentSize}-${value}`] + ' ';
    }, '').trim();
} 


// WEBPACK FOOTER //
// ./src/baseComponents/directives/Offset/classNames.js